import http from "../utils/http"

/**
 * 地址
 * @param {object} params
 */
export function getArea(params) {
    return http({
        url: "/api/address/lists",
        data: params
    })
}

/**
 * 获取地区
 */
export function getCity(params) {
    return http({
        url: "/api/address/city",
        data: params
    })
}

/**
 * 获取地区列表（省市区级联）
 */
export function getRegionList() {
    return http({
        url: "/api/address/region_list",
        method: "get"
    })
}
